export default __webpack_public_path__ + "static/media/vectorforward.abe1ff60.svg";